import React, {useEffect, useRef, useState} from "react";

const RowDropdown = ({hide, buttons, doNotShow}) => {
    const [isHidden, setIsHidden] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const useOutsideAlerter = ref => {
        const handleClickOutside = event => {
            if (ref.current && !ref.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        useEffect(() => {
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        });
    };

    const [items, setItems] = useState([]);

    useEffect(() => {
        if (buttons !== undefined) {
            setItems(buttons);
            if (
                buttons.every(x => x === undefined) ||
                buttons.every(x => x === false)
            ) {
                setIsHidden(true);
            } else {
                setIsHidden(hide);
            }
        }
    }, [buttons]);

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);

    return (
        <div
            className={
                "dropdown-item" +
                (isHidden ? " hide" : "") +
                (doNotShow ? " onHover" : "")
            }
            onClick={() => setDropdownOpen(true)}
            ref={wrapperRef}
        >
            <div className="wrap">
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div
                className={"dropdown-menu-container" + (dropdownOpen ? " show" : "")}
            >
                <ul>
                    {items.map((item, index) => {
                        return <li key={index}>{item}</li>;
                    })}
                </ul>
            </div>
        </div>
    );
};

export default RowDropdown;
